// extracted by css-extract-rspack-plugin
export default {"icon":"ConstructorPagesMiniGrid_icon__jlt5x","pageItem":"ConstructorPagesMiniGrid_pageItem__INfaP","accordion":"ConstructorPagesMiniGrid_accordion__IkXBy"};